import moment from 'moment';
import 'moment-timezone';
import { DATE_PICKER_FORMAT, isSameDay, SERVER_TIMEZONE, } from '@ally/date-utils';
import { getBalance, isExternal } from '@ally/transfer-account-utils';
import { validator } from '@ally/validator';
import { RemoteStatus } from '../../../Remote';
var DoesNotExceedAvailableBalance = function (amount, _a) {
    var fromAccount = _a.fromAccount, values = _a.values, withdrawalDate = _a.withdrawalDate;
    // If from account is external, skip validation
    if (!fromAccount || isExternal(fromAccount))
        return true;
    // If the delivery date is not valid, skip validation
    if (!values.deliveryDate)
        return true;
    var deliveryDate = moment.tz(values.deliveryDate, DATE_PICKER_FORMAT, true, SERVER_TIMEZONE);
    if (!deliveryDate.isValid())
        return true;
    // If delivery date is today, check balance
    var today = moment.tz(SERVER_TIMEZONE);
    var isSameDayDelivery = isSameDay(deliveryDate, today);
    if (isSameDayDelivery)
        return amount <= getBalance(fromAccount);
    // If there is no withdrawal date, skip validation
    if (withdrawalDate.status !== RemoteStatus.Loaded)
        return true;
    // If withdrawal date is not today skip validation
    var isSameDayWithdrawal = isSameDay(withdrawalDate.data, today);
    if (!isSameDayWithdrawal)
        return true;
    // Check balance
    return amount <= getBalance(fromAccount);
};
export var DoesNotExceedAvailableBalanceErrorMessage = "Your transfer amount can't exceed the available balance of your account.";
export var DoesNotExceedAvailableBalanceValidator = validator(DoesNotExceedAvailableBalance, DoesNotExceedAvailableBalanceErrorMessage);
//# sourceMappingURL=DoesNotExceedAvailableBalance.js.map